import { apiClient } from './client';
import type {
    Setting,
    SettingCreateInput,
    SettingUpdateInput,
} from '../../types/entities';

export const settingsApi = {
    /**
     * Get all settings for a tenant
     * GET /tenants/:tenantSlug/settings
     */
    getAllForTenantBySlug: async (tenantSlug: string): Promise<Setting[]> => {
        return apiClient.get<Setting[]>(`/tenants/${tenantSlug}/settings`);
    },

    /**
     * Get a single setting by ID
     * GET /tenants/:tenantSlug/settings/:id
     */
    getByIdBySlug: async (tenantSlug: string, id: number): Promise<Setting> => {
        return apiClient.get<Setting>(`/tenants/${tenantSlug}/settings/${id}`);
    },

    /**
     * Create a new setting
     * POST /tenants/:tenantSlug/settings
     */
    createBySlug: async (
        tenantSlug: string,
        data: SettingCreateInput
    ): Promise<Setting> => {
        return apiClient.post<Setting>(`/tenants/${tenantSlug}/settings`, data);
    },

    /**
     * Update a setting
     * PUT /tenants/:tenantSlug/settings/:id
     */
    updateBySlug: async (
        tenantSlug: string,
        id: number,
        data: SettingUpdateInput
    ): Promise<Setting> => {
        return apiClient.put<Setting>(
            `/tenants/${tenantSlug}/settings/${id}`,
            data
        );
    },

    /**
     * Delete a setting
     * DELETE /tenants/:tenantSlug/settings/:id
     */
    deleteBySlug: async (tenantSlug: string, id: number): Promise<void> => {
        return apiClient.delete<void>(`/tenants/${tenantSlug}/settings/${id}`);
    },
};
